import React, { useState } from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import { useSelector, useDispatch } from 'react-redux';

import Button from 'components/Button';
import CheckBox from 'components/CheckBox';
import Modal from 'components/ModalProvider/Modal/Modal';

import CashbackActivate from 'features/users/view/mobile/Modals/CashbackActivate/CashbackActivate';
import { actions as reportsActions } from 'features/reports/redux';

import './CashbackActionModal.scss';

const b = block('cashback-action-modal-mobile');

const CashbackActionModal = ({ type, closeFunction }) => {
  const locale = useSelector(state => state.locale.locale);
  const dispatch = useDispatch();
  const [forUsers, setForUsers] = useState(true);
  const [playersOnly, setPlayersOnly] = useState(false);
  const [agentsOnly, setAgentsOnly] = useState(true);
  const [isCashbackActivateModalOpen, setIsCashbackActivateModalOpen] = useState(false);

  const isActivate = type === 'activate';

  if (type === 'terms') {
    return (
      <div className={b()}>
        <div className={b('title')}>123</div>
        <div className={b('button')}>
          <Button text={locale.close} callBack={closeFunction} />
        </div>
      </div>
    );
  }

  const handleActivateCashbackForStructure = () => {
    dispatch(
      reportsActions.activateCashbackForStructure({
        activate: isActivate,
        isPlayersOnly: playersOnly,
        isAgentsOnly: agentsOnly,
        isDirectStructureOnly: !forUsers,
      }),
    );
    closeFunction();
  };

  return (
    <div className={b()}>
      <div className={b('title')}>{isActivate ? locale.activateForItsUsers : locale.deactivateForItsUsers}</div>
      <div className={b('actions')}>
        <div className={b('actions-item')}>
          <div className={b('actions-item-header')}>
            <div className={b('actions-item-checkbox')}>
              <CheckBox type="circle" checked={forUsers} onChange={() => setForUsers(!forUsers)} />
            </div>
            <div className={b('actions-item-title')}>
              {isActivate ? locale.activateForItsUsers : locale.deactivateForItsUsers}
            </div>
          </div>
          {forUsers && (
            <div className={b('actions-item-checkboxes')}>
              <div className={b('actions-item-header')}>
                <div className={b('actions-item-checkbox')}>
                  <CheckBox checked={playersOnly} onChange={() => setPlayersOnly(!playersOnly)} />
                </div>
                <div className={b('actions-item-title')}>{locale.playersOnly}</div>
              </div>
              <div className={b('actions-item-header')}>
                <div className={b('actions-item-checkbox')}>
                  <CheckBox checked={agentsOnly} onChange={() => setAgentsOnly(!agentsOnly)} />
                </div>
                <div className={b('actions-item-title')}>{locale.agentOnly}</div>
              </div>
            </div>
          )}
        </div>
        <div className={b('actions-item')}>
          <div className={b('actions-item-header')}>
            <div className={b('actions-item-checkbox')}>
              <CheckBox type="circle" checked={!forUsers} onChange={() => setForUsers(!forUsers)} />
            </div>
            <div className={b('actions-item-title')}>
              {isActivate ? locale.activateForEntireStructure : locale.deactivateForEntireStructure}
            </div>
          </div>
        </div>
      </div>
      <div className={b('button')}>
        <Button
          text={locale.save}
          callBack={isActivate ? () => setIsCashbackActivateModalOpen(true) : handleActivateCashbackForStructure}
        />
      </div>
      {isCashbackActivateModalOpen && (
        <Modal
          closeFunction={() => setIsCashbackActivateModalOpen(false)}
          content={
            <CashbackActivate
              closeFunction={() => setIsCashbackActivateModalOpen(false)}
              callback={handleActivateCashbackForStructure}
            />
          }
        />
      )}
    </div>
  );
};

CashbackActionModal.propTypes = {
  type: PropTypes.string.isRequired,
  closeFunction: PropTypes.func.isRequired,
};

export default CashbackActionModal;
